<template>
  <a-row :gutter="24" style="height: 100%">
    <a-col :md="24" :sm="24" style="height: 100%">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表类型')">
                <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请选择表类型')" dictCode="meter_type" />
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="12" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('最新告警时间')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    @change="onDateRangeChange"
                    @ok="onOk"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('处理状态')">
                  <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                    <a-select-option value="0"> {{ $t('未处理') }} </a-select-option>
                    <a-select-option value="1"> {{ $t('处理中') }} </a-select-option>
                    <a-select-option value="2"> {{ $t('已处理') }} </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('故障类型')">
                  <a-select v-model="queryParam.meterWarnType" :placeholder="$t('请选择故障类型')">
                    <a-select-option v-for="(val, key) in meterWarnTypeObj" :value="key" :key="key">
                      {{ $t(meterWarnTypeObj[key]) }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a-button type="primary" icon="download" @click="handleExportXls($t('异常状态'))" style="margin-left: 8px"
                  >{{ $t('导出') }}</a-button
                >
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :components="drag(columns)"
          @change="handleTableChange"
        >
          <span
            slot="meterDealDescriptionSlot"
            slot-scope="text, record"
            :title="
              record.meterDealStatus == 1
                ? record.meterDealDescription1
                : record.meterDealStatus == 2
                ? record.meterDealDescription2
                : record.meterDealDescription0
            "
          >
            {{
              record.meterDealStatus == 1
                ? record.meterDealDescription1
                : record.meterDealStatus == 2
                ? record.meterDealDescription2
                : record.meterDealDescription0
            }}
          </span>
          <span slot="meterDealStatus" slot-scope="text, record">
            <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
            <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
            <label v-else class="wait-status">{{ $t('未处理') }}</label>
          </span>
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="readingAbnormal(record)" :disabled="record.meterDealStatus == 2">{{ $t('处理') }}</a>
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          </span>
        </a-table>
      </div>
      <!-- 地图 -->
      <div style="width: 100%; height: 400px" id="amapDiv">
        <baidu-map
          :center="center"
          :zoom="zoom"
          :style="{ height: '100%' }"
          :scroll-wheel-zoom="scrollZoom"
          NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE"
          @ready="mapReady"
        >
          <!-- 缩放控件 -->
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
          <!-- 定位控件 -->
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <!-- 比例尺控件 -->
          <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-scale>
          <!-- 信息窗体 -->
          <bm-info-window :position="position" :show="show" @close="infoWindowClose" @open="infoWindowOpen">
            <div style="width: 100%; display: flex; justify-content: space-between; font-weight: bold">
              <div style="flex: 1">
                <div>{{ $t('用户名称') }}：{{ mapInfo.userName }}</div>
                <div>{{ $t('表类型') }}：{{ mapInfo.mtName }}</div>
                <div>{{ $t('用户经度') }}：{{ mapInfo.user_meter_lng }}</div>
                <div>{{ $t('用户纬度') }}：{{ mapInfo.user_meter_lat }}</div>
              </div>
            </div>
          </bm-info-window>
        </baidu-map>
      </div>
    </a-col>
    <meter-readingAbnormal-last-modal
      ref="readingAbnormalLastModal"
      @ok="modalFormOk"
    ></meter-readingAbnormal-last-modal>
    <meter-readingAbnormal-last-detail-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></meter-readingAbnormal-last-detail-modal>
  </a-row>
</template>
    <script>
import { getAction, deleteAction, postAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import { meterWarnTypeObj } from '@/utils/constants/commonConstant'
import { isUndefined, isEmptyObject } from '@/utils/validate'
import MeterReadingAbnormalLastModal from '@/views/meterAlarmManagement/modules/MeterReadingAbnormalLastModal'
import MeterReadingAbnormalLastDetailModal from '@/views/meterAlarmManagement/modules/MeterReadingAbnormalLastDetailModal'
import Vue from 'vue'
export default {
  name: 'alarmIndex',
  mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
  components: {
    JInput,
    MeterReadingAbnormalLastModal,
    MeterReadingAbnormalLastDetailModal,
  },
  data() {
    return {
      collapsed: false,
      meterWarnTypeObj,
      data: [],
      visible: false,
      description: '',
      url: {
        list: '/jeecg-charge/meter/meterUpDataFaultLastRecord/list',
        exportXlsUrl: '/jeecg-charge/meter/meterUpDataFaultLastRecord/exportXls',
      },
      queryParam: {
        importantFlag: 1,
      },
      BMap: '',
      map: '',
      center: { lng: 118.904, lat: 31.915 }, //中心坐标
      centerPoint: { lng: 118.904, lat: 31.915 },
      zoom: 4, //初始缩放比
      scrollZoom: true, //允许鼠标滚轮缩放
      mapInfo: {},
      position: {},
      show: false,
      iconList: {
        0: require('@/assets/inspectionImage/circle_red.png'),
        1: require('@/assets/inspectionImage/circle_green.png'),
        2: require('@/assets/inspectionImage/circle_gray.png'),
      },
    }
  },
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表类型'),
          align: 'center',
          dataIndex: 'mtName',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('用户编号'),
          align: 'center',
          dataIndex: 'userId',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户姓名'),
          align: 'center',
          dataIndex: 'userName',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户手机号'),
          align: 'center',
          dataIndex: 'userPhone',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('处理进度'),
          align: 'center',
          dataIndex: 'meterDealStatus',
          scopedSlots: { customRender: 'meterDealStatus' },
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('故障类型'),
          align: 'center',
          dataIndex: 'meterWarnType',
          width: 150,
          ellipsis: true,
          customRender: (t, r, index) => {
            const data = meterWarnTypeObj
            if (isUndefined(data[t])) {
              return this.$t('其他')
            }
            return this.$t(data[t])
          },
        },
        {
          title: this.$t('本轮告警次数'),
          align: 'center',
          dataIndex: 'meterEpicyclicWarnTimes',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('总告警次数'),
          align: 'center',
          dataIndex: 'meterTotalWarnTimes',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('最新告警时间'),
          align: 'center',
          dataIndex: 'updateTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('本轮告警起始时间'),
          align: 'center',
          dataIndex: 'createTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('处理时间'),
          align: 'center',
          dataIndex: 'meterDealTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('处理人'),
          align: 'center',
          dataIndex: 'meterDealBy',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    init(params) {
      this.searchReset()
      this.queryParam = Object.assign({},this.queryParam, params)
      this.loadData(1)
      this.mapReady({ BMap: this.BMap, map: this.map })
    },
    searchReset() {
      this.queryParam = {
        importantFlag: 1,
      }
      this.loadData(1)
    },
    readingAbnormal(record) {
      //处理异常界面点击跳转
      this.$refs.readingAbnormalLastModal.edit(record)
      this.$refs.readingAbnormalLastModal.title = this.$t('处理异常')
    },
    //地图默认方法
    mapReady({ BMap, map }) {
      let that = this
      this.BMap = BMap
      this.map = map
      map.enableDragging()
      map.enableScrollWheelZoom()
      map.enableDoubleClickZoom()
      map.enablePinchToZoom()
      map.enableKeyboard()
      map.clearOverlays()
      let params = this.getQueryParams()
      params.pageSize = 1000
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          that.dataSource = res.result.records
          that.dataSource.forEach(item => {
            if (item.user_meter_lng && item.user_meter_lat) {
              var point = {
                lng: item.user_meter_lng,
                lat: item.user_meter_lat,
              }
              let myIcon = new BMap.Icon(
                //也可以设置不同坐标点上的icon，需要自己定义
                require('@/assets/inspectionImage/circle_red.png'),
                new BMap.Size(40, 40), //图标可视区域大小
                { anchor: new BMap.Size(18, 18) } //图标定位点相对于图标左上角的偏移量
              )
              myIcon.setImageSize(new BMap.Size(30, 30)) // 设置icon大小
              var marker = new BMap.Marker(point, { icon: myIcon }) // 创建标注
              map.addOverlay(marker) // 将标注添加到地图中
              //icon标识内容位置
              let label = new BMap.Label(item.id, { offset: new BMap.Size(3, 0) })
              // 文本标识样式
              label.setStyle({
                // fontWeight: 600,
                fontSize: '14px',
                color: 'black',
                backgroundColor: '#fff',
                border: '1px solid #000',
                display: 'none',
              })
              marker.setLabel(label) // 为icon添加文本标识
            }
          })
        }
      })
      this.map.addEventListener('click', e => {
        that.mapInfo = that.dataSource.find(al => al.id == e.cb.Bc.textContent)
        that.position = {
          lng: that.mapInfo && that.mapInfo.user_meter_lng,
          lat: that.mapInfo && that.mapInfo.user_meter_lat,
        }
        that.show = true
      })
    },
    // 关闭窗体
    infoWindowClose() {
      this.show = false
    },
    // 打开窗体
    infoWindowOpen() {
      this.show = true
    },
  },
}
</script>
    <style scoped lang="less">
.drawer-bootom-button {
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.qrcodeInfo {
  color: #222;
  margin: 5px 0;
}
</style>
    <style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}
</style>
    <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/* .new-table-card .ant-card-body .table-fixed {
  height: calc(100% - 180px);
} */
</style>